import styled, { keyframes } from 'styled-components';

/**
 * Shared visual constants and components for the caption side-panel
 * views so the original-language `KaraokeLinesView` and the translated
 * `TranslatedCaptionsView` render rows with the same height, rhythm,
 * font, divider, and cursor.
 *
 * Keeping these in one place is what guarantees toggling between
 * original and translated does not visibly change row metrics or
 * cursor position.
 */

// Per-row text size. Both views previously rendered at different
// effective sizes (translated used the non-existent `var(--text-base)`
// which fell back to ~16px while English inherited `var(--text-sm)`
// = 14px from the parent). Pinning both views to this shared token
// keeps row heights aligned.
export const CAPTION_LINE_FONT_SIZE = 'var(--text-sm)';

// Browser default line-height for body text (~1.2). Used inside each
// caption row so multi-line wrapping in the translated path matches
// the English path's inline-flow line rhythm.
export const CAPTION_LINE_LINE_HEIGHT = '1.2';

// Hairline divider color for both views.
export const CAPTION_LINE_DIVIDER_COLOR = 'rgba(255, 255, 255, 0.18)';

// Vertical breathing room above and below each caption row. Both
// views render their per-caption block with this padding plus a
// 1px border-bottom divider, so toggling between them does not
// change row height or rhythm.
export const CAPTION_LINE_VERTICAL_PADDING = '16px';

const cursorAnimation = keyframes`
  100% {
    opacity: 0;
  }
`;

/**
 * Inline cursor span used at the start of the active caption row by
 * both the original and translated caption views. Identical metrics
 * in both paths so toggling languages does not shift the cursor.
 */
export const CaptionCursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 1.2em;
  vertical-align: text-bottom;
  background-color: #dfb615;
  border-radius: 1px;
  animation: ${cursorAnimation} steps(2) 1.5s infinite;
  will-change: opacity;
`;
